import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { Component } from "react";
import styled from "@emotion/styled";

var AudioLevelDiv = styled.div({
  width: "290px",
  height: "35px",
  marginLeft: "-10px",
  display: "inline-block",
  paddingTop: "8px",
  position: "relative",

  "& .bar": {
    height: "45px",
    width: "12px",
    marginLeft: "4px",
    marginRight: "4px",
    position: "relative",
    top: "-10px",
    display: "inline-block",
    backgroundColor: "#E6E6E6",
    borderRadius: "11px"
  },

  "& .lit": {
    backgroundColor: "#99CC66"
  }
});

export var AudioLevel = function (_Component) {
  _inherits(AudioLevel, _Component);

  function AudioLevel() {
    var _temp, _this, _ret;

    _classCallCheck(this, AudioLevel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.litUp = function (pos) {
      return _this.props.value * 10 >= pos;
    }, _this.barClass = function (pos) {
      return _this.litUp(pos) ? "lit bar" : "bar";
    }, _this.render = function () {
      // How does JS not have a native range function?

      return React.createElement(
        AudioLevelDiv,
        null,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(function (v) {
          return React.createElement("div", { key: v, className: _this.barClass(v) });
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return AudioLevel;
}(Component);

export default AudioLevel;